module.exports = __webpack_public_path__ + "static/media/nonord-c-3.53a4092d.mp3";